import './styles.css';
import { GameApp } from './app/GameApp.js';

const mount = document.querySelector('#app');
const app = new GameApp({ mount });
app.start();
